import React, {
  useCallback, useContext, useEffect, useRef, useState
} from 'react';
import {
  arrayOf, bool, element, func, number, oneOf, shape, string
} from 'prop-types';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';
import { Favorite } from '@thd-olt-component-react/save-to-favorites';
import { Price } from '@thd-olt-component-react/price';
import { FulfillmentPodShipping, FulfillmentPodStore, podFulFillmentUtils } from '@thd-olt-component-react/fulfillment';
import { SuperSkuMiniSwatches } from '@thd-olt-component-react/super-sku';
import { Promotion } from '@thd-olt-component-react/promotion';
import {
  params,
  string as stringType,
  shape as shapeType,
  bool as boolType,
  client,
  arrayOf as arrayType,
  extend,
  number as numberType, useDataModel, useLazyDataModel
} from '@thd-nucleus/data-sources';
import { ExperienceContext, getDomPath } from '@thd-nucleus/experience-context';

import { ProductPodContext } from '../ProductPodContext';

import { ProductPodGroupContext } from '../ProductPodGroupContext';
import { checkScheduleAMeasureEligibility, getAtcInfo, productPodClasses } from '../utils';
import { publish } from '../../analytics';
import {
  BADGE_CLICKTHROUGH,
  CHECK_NEARBY_STORE,
  COMPARE,
  PRODUCT,
  PRODUCT_POD_COMPARE,
  PRODUCT_DETAILS,
  PRODUCT_IMAGE,
  PRODUCT_POD_ATC,
  PRODUCT_POD_CLICK,
  PRODUCT_POD_IRG_ATC,
  PRODUCT_POD_SIMILAR,
  RATING,
  SAVE_TO_FAVORITE,
} from '../constants';
import { ProductDefault } from '../subcomponents/product-default/ProductDefault';
import '../product-pod.scss';
import { ProductMobileSingleColumn } from '../subcomponents/product-mobile/ProductMobileSingleColumn';

export const ProductPodDefault = (props) => {
  const {
    brandMaxLine,
    channelFromTest,
    className,
    comparable,
    dpdNewTab,
    hideATC,
    hideFavorites,
    hideLimitPerOrder,
    hidePriceBadge,
    hideSavingsText,
    hideShippingInfo,
    hideShopThisCollection,
    hover,
    hoverDelay,
    installationServices,
    isEtchOne,
    irgSectionName,
    itemId,
    maxKeyFeatures,
    miniOptions,
    mobilePodType,
    noATCFulfillment,
    onCartFailure,
    onCartSuccess,
    onClick,
    onCompare,
    onError,
    onHover,
    onHoverExit,
    onHoverSuperSku: onHoverSuperSkuProp,
    onFavoriteChange,
    onRemove,
    onSelectedForCompare,
    onShowSimilarClick,
    onSuperSkuChange,
    pageNumber,
    pageType,
    podCount,
    podIndex,
    podType,
    position,
    preFetchProductData,
    removable,
    selectedForCompare,
    showAisleAndBay,
    showDisabledATC,
    showDpdPod,
    showFavoritesCount,
    showModelNumber,
    showSeeMoreOptions,
    showShippingInfoInHover,
    showSimilarItem,
    showStoreInfo,
    showSSKUMiniSwatches,
    showQuantityBox,
    stfTopRight,
    storeId,
    swatchCount,
    target,
    testId,
    titleMaxLine,
    zipCode,
    isBOLDCategory,
    showKPF,
    showSample,
    ignoreAnalytics,
    sharedSection,
  } = props;

  // @todo this is bad. should be prop driven and consider the cookie as an extrnal global
  let searchCookie = '';
  if (typeof window !== 'undefined') {
    searchCookie = window.cookieUtils?.readBrowserCookie('x-ttsearch') || '';
  }
  const searchOptions = searchCookie.split(',');
  const showSimilarItemButton = searchOptions.filter((opt) => opt === 'OOS_button').length === 1;
  const showSimilarLinkInstock = searchOptions.filter((opt) => opt === 'INSTOCK_link').length === 1;

  const { channel, hosts } = useContext(ExperienceContext);
  const { handleProductPodExpansion, setOverlayState } = useContext(ProductPodGroupContext);

  const [state, setState] = useState({
    buyMoreSaveMore: false,
    itemId,
    isHovered: false,
    podInteractionNumber: 1,
    selectedItemId: null,
    showExactPrice: false,
    previousItemId: null,
    itemIdForSubComponents: itemId,
    canonicalUrl: null,
    quantity: 1,
  });

  const onProductLinkClick = useCallback((evt, opts) => {
    if (onClick) {
      onClick(evt, opts);
    }
  }, []);

  const productRef = useRef(null);
  const preFetchTimerRef = useRef(null);

  const itemIdProp = state.selectedItemId || itemId;

  const { data, loading, error } = useDataModel('product', {
    variables: {
      itemId: itemIdProp,
      storeId,
      zipCode,
      skipInstallServices: !installationServices,
    },
    skip: !itemIdProp,
    fetchPolicy: state.fetchPolicy
  });

  const [prefetchReq, prefetchRes] = useLazyDataModel('product', {
    variables: {
      itemId,
      storeId,
      zipCode,
    }
  });

  if (data) {
    productRef.current = data;
  }

  useEffect(() => {
    return () => {
      // On Component un mounting close see similar item window.
      if (setOverlayState) {
        setOverlayState(false);
      }
    };
  }, []);

  useEffect(() => {
    if (data?.product) {
      setState({
        ...state,
        itemIdForSubComponents: data.product?.itemId,
        canonicalUrl: data.product?.identifiers?.canonicalUrl
      });
    }
  }, [data?.product]);

  useEffect(() => {
    if (data?.product && !data?.product?.itemId && onError) {
      onError({ data, loading, error });
    }
  }, [data?.product]);

  useEffect(() => {
    if (error && onError) {
      onError({ data, loading, error });
    }
  }, [error]);

  const productPodRef = useRef(null);

  if ((error || loading) && !data && !productRef?.current) return null;

  const { product } = data || productRef?.current || {};
  if (!product) return null;
  if (!product.itemId) return null;

  const isScheduleAMeasureEligible = checkScheduleAMeasureEligibility(product);

  const { isFulfillable } = podFulFillmentUtils;
  const { info } = product || {};
  const { isBuryProduct = false } = info || {};
  const hideSimilarItemLink = isFulfillable(product) || !isBuryProduct;

  const publishAnalytics = (eventName, action) => {
    if (ignoreAnalytics) return;
    let eventData;

    if (eventName === PRODUCT_POD_ATC) {
      eventData = getAtcInfo({ pageType, podType, position, product });
      eventData.path = getDomPath(productPodRef);
    } else if (eventName === PRODUCT_POD_IRG_ATC) {
      eventData = {
        sku: itemId,
        displayPosition: position + 1
      };
    } else {
      eventData = {
        podPageNumber: pageNumber,
        podPosition: position + 1,
        podType: PRODUCT,
        podPageResults: podCount,
        podAction: action,
        podInteractionNumber: state?.podInteractionNumber,
        podAnchorSku: itemId,
        sponsoredProduct: !!(product?.info?.isSponsored),
        sponsoredClickBeacon: product?.info?.sponsoredBeacon?.onClickBeacon,
        target,
        badges: product?.badges,
        path: getDomPath(productPodRef)
      };
      setState({
        ...state,
        podInteractionNumber: state.podInteractionNumber + 1
      });
    }

    if (eventName === PRODUCT_POD_CLICK && product?.badges?.length) {
      publish(BADGE_CLICKTHROUGH, { badges: product.badges, pageType });
    }
    if (irgSectionName) {
      eventData.irgSectionName = irgSectionName;
    }
    publish(eventName, eventData);
  };

  const onChangeSuperSku = (sskuData) => {

    if (onSuperSkuChange) {
      onSuperSkuChange(sskuData);
    }
    if (setOverlayState) {
      setOverlayState(false);
    }
    setState({
      ...state,
      selectedItemId: sskuData?.itemId,
      showExactPrice: true,
      isHovered: false
    });
  };

  const onHoverSuperSku = (sskuData) => {
    if (onHoverSuperSkuProp) {
      onHoverSuperSkuProp(sskuData);
    }
    setState({
      ...state,
      previousItemId: sskuData?.isHovered ? state.selectedItemId || itemId : null,
      selectedItemId: sskuData?.itemId,
      isHovered: sskuData?.isHovered,
      itemIdForSubComponents: state.selectedItemId || itemId,
      fetchPolicy: 'cache-first',
    });
  };

  const onProductPodHover = (hoveredItemId) => {
    if (onHover) {
      preFetchTimerRef.current = setTimeout(() => {
        onHover(hoveredItemId);
      }, hoverDelay);
    }
    if (preFetchProductData) {
      preFetchTimerRef.current = setTimeout(() => {
        prefetchReq({
          variables: {
            itemId: hoveredItemId
          }
        });
      }, 200);
    }
  };

  const onProductPodHoverExit = () => {
    if (onHoverExit) {
      onHoverExit();
    }
    clearInterval(preFetchTimerRef.current);
  };

  const onSavingsCenterToggle = () => {
    setState({
      ...state,
      buyMoreSaveMore: !state.buyMoreSaveMore
    });
  };

  const onQuantityChange = ({ quantity }) => {
    setState({
      ...state,
      quantity: Number(quantity)
    });
  };

  const handleClick = (event, action) => {
    const customExperience = !!product?.info?.globalCustomConfigurator?.customExperience;
    if (!customExperience && onClick) {
      onClick(event, product, action);
    }

    publishAnalytics(PRODUCT_POD_CLICK, action);
  };

  const chooseYourOptionsClick = (event) => {
    if (onClick) {
      onClick(event, product);
    }
  };

  const context = {
    brandMaxLine,
    buyMoreSaveMore: state?.buyMoreSaveMore,
    channel,
    chooseYourOptionsClick,
    comparable,
    hosts,
    hover,
    hideATC,
    hideFavorites,
    hideLimitPerOrder,
    hidePriceBadge,
    hideSavingsText,
    hideSimilarItemLink,
    hideShippingInfo,
    hideShopThisCollection,
    itemId: productRef.current?.product?.itemId || state.itemIdForSubComponents,
    canonicalUrl: state.canonicalUrl,
    isHovered: state.isHovered,
    isScheduleAMeasureEligible,
    previousItemId: state.previousItemId,
    onCompare,
    onCompareAnalytics: () => {
      publishAnalytics(PRODUCT_POD_COMPARE, COMPARE);
    },
    onSavingsCenterToggle,
    onSelectedForCompare,
    onHeaderClick: (event) => handleClick(event, PRODUCT_DETAILS),
    onImageClick: (event) => handleClick(event, PRODUCT_IMAGE),
    onRatingClick: (event) => handleClick(event, RATING),
    onCheckNearbyStoresClick: () => {
      publishAnalytics(PRODUCT_POD_CLICK, CHECK_NEARBY_STORE);
    },
    onFavoriteClick: () => {
      publishAnalytics(PRODUCT_POD_CLICK, SAVE_TO_FAVORITE);
    },
    onSimilarItemsClick: (similarButtonEnabled) => {
      const path = getDomPath(productPodRef);
      publish(PRODUCT_POD_SIMILAR, { path, product });
      handleProductPodExpansion(itemId, position, productPodRef, similarButtonEnabled);
    },
    dpdNewTab,
    onProductLinkClick,
    onShowSimilarClick,
    onChangeSuperSku,
    onHoverSuperSku,
    onFavoriteChange,
    onCartSuccess,
    onCartFailure,
    onQuantityChange,
    onRemove,
    quantity: state.quantity,
    maxKeyFeatures,
    mobilePodType,
    noATCFulfillment,
    pageType,
    podType,
    podIndex,
    position,
    product,
    productPodRef,
    publishAnalytics,
    removable,
    selectedForCompare,
    selectedItemId: state.selectedItemId,
    showAisleAndBay,
    showModelNumber,
    showSeeMoreOptions,
    showStoreInfo,
    showExactPrice: state.showExactPrice,
    showShippingInfoInHover,
    showSimilarItem,
    showSSKUMiniSwatches,
    showQuantityBox,
    target,
    titleMaxLine,
    showFavoritesCount,
    stfTopRight,
    storeId,
    showDisabledATC,
    swatchCount,
    isBOLDCategory,
    showKPF,
    showSample,
    sharedSection,
    showSimilarItemButton,
    showSimilarLinkInstock
  };

  const isMobile = channel === 'mobile' || channelFromTest === 'mobile';

  return (
    <div
      className={productPodClasses({
        channel,
        className,
        hover,
        podType,
        mobilePodType
      })}
      data-testid={testId}
      data-automation-id="podnode"
      ref={productPodRef}
      onMouseEnter={() => onProductPodHover(itemId)}
      onMouseLeave={() => onProductPodHoverExit()}
      data-type="product"
    >
      <meta data-prop="productID" content={itemId} />
      <ProductPodContext.Provider value={context}>
        {isMobile && mobilePodType === 'singleColumn' ? (
          <ProductMobileSingleColumn
            isEtchOne={isEtchOne}
            showDpdPod={showDpdPod}
            showKPF={showKPF}
          />
        ) : (podType === 'default' && <ProductDefault />)}
      </ProductPodContext.Provider>
    </div>
  );
};

ProductPodDefault.propTypes = {
  brandMaxLine: number,
  channelFromTest: string,
  className: string,
  comparable: bool,
  dpdNewTab: bool,
  hideATC: bool,
  hideFavorites: bool,
  hideLimitPerOrder: bool,
  hidePriceBadge: bool,
  hideSavingsText: bool,
  hideShippingInfo: bool,
  hideShopThisCollection: bool,
  hover: bool,
  hoverDelay: number,
  installationServices: bool,
  isEtchOne: bool,
  irgSectionName: string,
  itemId: string,
  maxKeyFeatures: number,
  miniOptions: shape({
    disabled: bool,
    onAction: func,
    enableATC: bool,
    silentATC: bool,
    onlyShowIfFulfillable: bool,
    inCartQuantity: number,
    callToActionSection: element
  }),
  mobilePodType: oneOf(['singleColumn', 'doubleColumn']),
  noATCFulfillment: bool,
  onCartFailure: func,
  onCartSuccess: func,
  onClick: func,
  onCompare: func,
  onError: func,
  onFavoriteChange: func,
  onRemove: func,
  onHover: func,
  onHoverExit: func,
  onHoverSuperSku: func,
  onSelectedForCompare: func,
  onShowSimilarClick: func,
  onSuperSkuChange: func,
  pageNumber: number,
  pageType: string,
  podCount: number,
  podIndex: number,
  podType: oneOf(['grouped', 'horizontal', 'sidebyside', 'default', 'mini', 'list']),
  position: number,
  preFetchProductData: bool,
  removable: bool,
  selectedForCompare: arrayOf(string),
  showAisleAndBay: bool,
  showDpdPod: bool,
  showFavoritesCount: bool,
  showModelNumber: bool,
  showSample: bool,
  showSeeMoreOptions: bool,
  showShippingInfoInHover: bool,
  showSimilarItem: bool,
  showStoreInfo: bool,
  showSSKUMiniSwatches: bool,
  showDisabledATC: bool,
  showQuantityBox: bool,
  stfTopRight: bool,
  storeId: string,
  // number of swatches to display when using the mini swatches (see ProductDefault)
  swatchCount: number,
  target: string,
  testId: string,
  titleMaxLine: number,
  zipCode: string,
  isBOLDCategory: bool,
  showKPF: bool,
  ignoreAnalytics: bool,
  sharedSection: string,
};

ProductPodDefault.defaultProps = {
  brandMaxLine: null,
  channelFromTest: null,
  className: null,
  comparable: false,
  dpdNewTab: false,
  hideATC: false,
  hideFavorites: false,
  hideLimitPerOrder: false,
  hidePriceBadge: false,
  hideSavingsText: false,
  hideShippingInfo: false,
  hideShopThisCollection: false,
  hover: false,
  hoverDelay: 200,
  installationServices: false,
  isEtchOne: false,
  irgSectionName: '',
  itemId: '',
  maxKeyFeatures: 0,
  miniOptions: {
    disabled: false,
    onAction: () => {},
    enableATC: true,
    silentATC: false,
    onlyShowIfFulfillable: false,
    inCartQuantity: 0,
    callToActionSection: null
  },
  mobilePodType: 'doubleColumn',
  noATCFulfillment: false,
  onCartFailure: () => {},
  onCartSuccess: () => {},
  onClick: null,
  onCompare: () => {},
  onError: null,
  onFavoriteChange: null,
  onHover: null,
  onHoverExit: null,
  onHoverSuperSku: null,
  onRemove: () => {},
  onSelectedForCompare: () => {},
  onShowSimilarClick: null,
  onSuperSkuChange: null,
  pageNumber: 1,
  pageType: 'browse',
  podCount: null,
  podIndex: 1,
  podType: 'default',
  position: 1,
  preFetchProductData: false,
  removable: false,
  selectedForCompare: [],
  showAisleAndBay: false,
  showDisabledATC: false,
  showDpdPod: false,
  showFavoritesCount: false,
  showModelNumber: false,
  showSeeMoreOptions: false,
  showShippingInfoInHover: false,
  showSimilarItem: false,
  showStoreInfo: false,
  showSSKUMiniSwatches: false,
  showQuantityBox: false,
  stfTopRight: false,
  storeId: '',
  swatchCount: 0,
  target: null,
  testId: null,
  titleMaxLine: null,
  zipCode: undefined,
  isBOLDCategory: false,
  showKPF: false,
  showSample: false,
  ignoreAnalytics: false,
  sharedSection: '',
};

ProductDefault.displayName = 'ProductDefault';

const installServices = shapeType({
  scheduleAMeasure: boolType()
});

if (installServices.skip) {
  installServices.skip('skipInstallServices', true);
}

ProductPodDefault.dataModel = extend({
  product: params({ itemId: stringType().isRequired(), dataSource: stringType() }).shape({
    itemId: stringType(),
    availabilityType: shapeType({
      discontinued: boolType(),
      type: stringType()
    }),
    badges: params({ storeId: stringType() }).arrayOf(shapeType({
      name: stringType(),
    })),
    details: shapeType({
      collection: shapeType({
        collectionId: stringType(),
        name: stringType(),
        url: stringType(),
      })
    }),
    favoriteDetail: client(shapeType({
      count: numberType()
    })),
    fulfillment: client(params({ storeId: stringType(), zipCode: stringType() }).shape({
      backordered: boolType(),
      backorderedShipDate: stringType(),
      seasonStatusEligible: boolType(),
      fulfillmentOptions: arrayType(shapeType({
        type: stringType(),
        fulfillable: boolType(),
        services: arrayType(shapeType({
          type: stringType(),
          hasFreeShipping: boolType(),
          freeDeliveryThreshold: numberType({ float: true }),
          locations: arrayType(shapeType({
            curbsidePickupFlag: boolType(),
            isBuyInStoreCheckNearBy: boolType(),
            distance: numberType({ float: true }),
            inventory: shapeType({
              isInStock: boolType(),
              isLimitedQuantity: boolType(),
              isOutOfStock: boolType(),
              isUnavailable: boolType(),
              quantity: numberType(),
              maxAllowedBopisQty: numberType(),
              minAllowedBopisQty: numberType()
            }),
            isAnchor: boolType(),
            storeName: stringType(),
            type: stringType(),
          }))
        }))
      }))
    })),
    identifiers: shapeType({
      brandName: stringType(),
      canonicalUrl: stringType(),
      modelNumber: stringType(),
      productType: stringType(),
      productLabel: stringType(),
      itemId: stringType(),
      storeSkuNumber: stringType()
    }),
    info: shapeType({
      isBuryProduct: boolType(),
      isSponsored: boolType(),
      isGenericProduct: boolType(),
      isLiveGoodsProduct: boolType(),
      sponsoredBeacon: shapeType({
        onClickBeacon: stringType(),
        onViewBeacon: stringType()
      }),
      sponsoredMetadata: shapeType({
        campaignId: stringType(),
        placementId: stringType(),
        slotId: stringType()
      }),
      globalCustomConfigurator: shapeType({
        customExperience: stringType()
      }),
      returnable: boolType(),
      isCustomKitchenCabinet: boolType().client(),
      isBrioSku: boolType().client(),
      hidePrice: boolType(),
      productSubType: shapeType({
        name: stringType(),
        link: stringType()
      }),
      categoryHierarchy: arrayType(stringType()),
      samplesAvailable: boolType()
    }),
    installServices,
    media: shapeType({
      image: shapeType({
        url: stringType()
      }),
      images: arrayType(shapeType({
        url: stringType(),
        type: stringType(),
        subType: stringType(),
        sizes: arrayType(stringType())
      }))
    }),
    reviews: shapeType({
      ratingsReviews: shapeType({
        averageRating: stringType(),
        totalReviews: stringType(),
      })
    })
  })
},
Favorite,
KeyProductFeatures,
FulfillmentPodStore,
FulfillmentPodShipping,
Price,
SuperSkuMiniSwatches,
Promotion,
);
